import { AbstractEntityService } from "./AbstractEntityService";
import { restService } from "./RestService";

export class WebsiteContentService extends AbstractEntityService {
    constructor(baseUrl) {
        super();
        this.baseUrl = baseUrl;
    }

    async findAll(propertyId) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, "Unable to load website content components");
        }
    }

    async findById(propertyId, componentId) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content/${componentId}`;
        try {
            return await super.find(url);
        } catch (error) {
            this.handleError(error, `Unable to load website component: ${componentId}`);
        }
    }

    async create(propertyId, component) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content`;
        try {
            return await super.create(url, component);
        } catch (error) {
            this.handleError(error, "Unable to create website component");
        }
    }

    async update(propertyId, componentId, component) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content/${componentId}`;
        try {
            return await super.update(url, component);
        } catch (error) {
            this.handleError(error, `Unable to update website component: ${componentId}`);
        }
    }

    async delete(propertyId, componentId) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content/${componentId}`;
        try {
            return await super.delete(url);
        } catch (error) {
            this.handleError(error, `Unable to delete website component: ${componentId}`);
        }
    }

    async uploadImages(propertyId, componentId, files) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content/${componentId}/images`;
        const formData = new FormData();
        files.forEach(file => formData.append('files', file));
        try {
            return await restService.post(url, formData, { 'Content-Type': 'multipart/form-data' });
        } catch (error) {
            this.handleError(error, `Unable to upload images for component: ${componentId}`);
        }
    }

    async deleteImages(propertyId, componentId, fileNames) {
        const url = `${this.baseUrl}/properties/${propertyId}/website-content/${componentId}/images`;
        try {
            return await restService.delete(url, fileNames);
        } catch (error) {
            this.handleError(error, `Unable to delete images for component: ${componentId}`);
        }
    }
}
